"use client";

import { Typography, Container } from "ct-design";
import { FunctionComponent, useMemo } from "react";
import { CityListProps } from "./types";
import "./styles.scss";
import DotLoader from "components/dotLoader";

const CityList: FunctionComponent<CityListProps> = (props) => {
  const { cities, cityListActive, handleSelectCity, loading, noData, onClose } =
    props;
  // Popular cities, Nearby citties, Suggestions

  //searchList => arrival, departure: search suggestion, popular cities, nearby cities

  const getCityList = useMemo(() => {
    if (cityListActive === "departure") {
      return cities[cityListActive].suggestions?.length
        ? cities[cityListActive].suggestions
        : cities[cityListActive].default;
    } else {
      return cities[cityListActive]?.suggestions.length
        ? cities[cityListActive].suggestions
        : cities[cityListActive]?.popular?.length
        ? cities[cityListActive].popular
        : cities[cityListActive].default;
    }
  }, [cities, cityListActive]);

  const getNearByList = useMemo(() => {
    if (
      cities?.arrival?.nearBy?.length &&
      cityListActive === "arrival" &&
      !cities?.arrival?.suggestions?.length
    ) {
      return cities.arrival.nearBy;
    } else [];
  }, [cities.arrival, cityListActive]);

  return (
    <>
      <div className="mb-4">
        {!loading ? (
          <p className="mt-4 px-6 mb-2 fs-3 fw-600 c-neutral-700">
            {cities[cityListActive].suggestions.length || noData[cityListActive]
              ? "SUGGESTIONS"
              : "POPULAR CITIES"}
          </p>
        ) : null}

        {!noData[cityListActive] && !loading ? (
          <>
            {getCityList.map((city, index) => (
              <div
                className="py-3 px-6 c-pointer item-hover"
                key={index}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();

                  handleSelectCity(city);
                }}
              >
                <Typography variant="B1">{city.cityName}</Typography>
              </div>
            ))}

            {getNearByList && getNearByList?.length > 0 ? (
              <>
                <div className="border-top-dotted mx-4 pt-4 ">
                  <p className="mb-2 fs-3 fw-600 mx-2 c-neutral-700">
                    NEARBY CITIES
                  </p>
                </div>
                {getNearByList.map((city, index) => (
                  <div
                    className="py-3 px-6 c-pointer item-hover"
                    key={index}
                    onClick={() => handleSelectCity(city)}
                  >
                    <Typography variant="B1">{city.cityName}</Typography>
                  </div>
                ))}
              </>
            ) : null}
          </>
        ) : null}
        {noData[cityListActive] && !loading ? (
          <div className="py-3 px-6 c-pointer" onClick={onClose}>
            <Typography variant="B1">No city found</Typography>
          </div>
        ) : null}

        {loading ? (
          <Container className="w-100p mt-4 flex flex-center">
            <DotLoader />
          </Container>
        ) : null}
      </div>
    </>
  );
};

export default CityList;
